import React from 'react';

import {ShadowCard, CtaButton} from '@optimaxdev/design-system';
import {connect, useDispatch, useSelector} from 'react-redux';

import {Timer} from 'desktop/components/helpers/timer/timer';
import {AppThunkDispatchType, ApplicationStoreType} from 'desktop/store';
import {useGetRouter} from 'hooks/router/router';

import {addUpsellFromSuccessPage} from '../../store/reducers/upsells/upsells';
import {
    getOrderLastData,
    getActiveUpsellName,
    getUpsellTimerState,
    getUpsellsState,
    getActiveUpsell,
    getOrderId,
} from '../../store/selectors/selectors';

import s from './simplePay.scss';

export type PropsType = {
    productName: string;
    endTime: number;
    paymentToken?: string;
    onClose: (event: React.SyntheticEvent) => void;
    isLoading: boolean;
    error: string;
};

/**
 * Payment popup on success page for buying with previous used paymentMethodToken
 */
export const SimplePay: React.FC<PropsType> = ({
    endTime,
    error,
    isLoading,
    onClose,
    paymentToken,
    productName,
}) => {
    const router = useGetRouter();
    const dispatch = useDispatch<AppThunkDispatchType>();
    const upsell = useSelector(getActiveUpsell);
    const orderId = useSelector(getOrderId);

    const clickHandler = () => {
        if (paymentToken) {
            dispatch(
                addUpsellFromSuccessPage({
                    meta: {router},
                    orderId,
                    paymentToken: String(paymentToken),
                    upsell,
                }),
            );
        }
    };

    return (
        <ShadowCard className={s.cardContainer} corner={4} saturate={2}>
            <div className={s.container}>
                <p className={s.description}>Add {productName} to your order</p>
                <div className={s.timer}>
                    <Timer endTime={endTime} size="extraSmall" />
                </div>
                <div className={s.button}>
                    <CtaButton
                        isDisabled={!paymentToken}
                        isLoading={isLoading}
                        onClick={clickHandler}
                        size="small"
                        isFull
                    >
                        Confirm
                    </CtaButton>
                </div>
                <button className={s.back} onClick={onClose} type="button">
                    go back
                </button>
                <p className={s.error}>{error}</p>
            </div>
        </ShadowCard>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
export const mapStateToProps = (store: ApplicationStoreType) => ({
    endTime: getUpsellTimerState(store),
    error: getUpsellsState(store).error,
    isLoading: getUpsellsState(store).status === 'pending',
    paymentToken: getOrderLastData(store).paymentMethodToken,
    productName: getActiveUpsellName(store),
});

export const SimplePayConnected = connect(mapStateToProps)(SimplePay);
